import { render, staticRenderFns } from "./BackOfficeDetail.vue?vue&type=template&id=f32edba4&scoped=true"
import script from "./BackOfficeDetail.vue?vue&type=script&lang=js"
export * from "./BackOfficeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32edba4",
  null
  
)

export default component.exports